<template>
    <div id="ModularNavigation">
        <b-navbar variant="faded" type="light">
            <b-navbar-brand v-for="nav in navOpts" :key="nav" :to="{ name: nav }" :active="$router.name == nav">
                {{ nav }}
            </b-navbar-brand>
        </b-navbar>
    </div>
</template>

<script>
const navOpts = [
    'Existencia acutal', // Módulos
    'Lotes de ingreso', // Módulos
    'Pedidos', // Módulos
];
export default {
    props: {
        navOpts: {
            type: Array,
            default: () => navOpts
        }
    }
}
</script>

<style lang="less">
#ModularNavigation {
	.navbar-brand.router-link-exact-active.open.active {
		color: var(--primary);
	}
	
	.navbar-expand {
		border: 1px solid hsla(0, 0%, 0%, 0.2);
		border-radius: 0.3em;
		background: white;
	}
}
</style>